import { NumberedList } from '@fiverr-private/list';
import withImpression from '../helpers/withImpression';

export default withImpression(NumberedList);
